import {
  createUserManager,
  createUserManagerWithRedirect,
  validateError,
} from "./helpers";
import { store } from '../store';
import { updateLogoutDate } from "../store/services/auth-service";

export var userManager = createUserManager()

export const signinRedirect = () => userManager.signinRedirect()

export const signinRedirectWithCallbackArgs = (args: string) => {
    if (args) {
        const redirectUri = userManager.settings.redirect_uri + "?callback_args=" + encodeURIComponent(args)
        userManager = createUserManagerWithRedirect(redirectUri);
    }
    userManager.signinRedirect()
}

export const signinRedirectCallback = () =>   userManager.signinRedirectCallback();

export async function signoutRedirect() {
    await updateLogoutDate();
    userManager.signoutRedirect();
}

export const signoutRedirectCallback = () => userManager.signoutRedirectCallback()

export async function getAccessToken() {
    const user = store.getState()?.authReducer?.authentication?.user
    return user?.access_token;
}